import { Icon } from "@repo/core/components/core/Icon";
import { IconNames } from "@repo/core/components/core/Icon/types";
import { menuItems } from "@repo/core/screens/Login/Welcome/menu-items";
import { HStack, Text, View } from "@gluestack-ui/themed";
import { ScrollView, VStack } from "@gluestack-ui/themed";
import WayupIllustration from "@repo/core/assets/images/wayup-illustration.svg";
import { Button } from "@repo/core/components/core/Button";
import { useWelcomeController } from "@repo/core/screens/Login/Welcome/controller";
import { StyleProp, ViewStyle } from "react-native";

const scrollViewContainerStyle: StyleProp<ViewStyle> = {
  flexGrow: 1,
  alignItems: "center"
};

export const Welcome = () => {
  const { handleContinue } = useWelcomeController();

  return (
    <View w="$100vw" h="$100vh">
      <ScrollView
        h="$full"
        w="$full"
        contentContainerStyle={scrollViewContainerStyle}
      >
        <View
          $base-px="$8"
          $base-w="$full"
          p="$4"
          alignItems="center"
          $sm-maxWidth="$128"
          gap="$8"
          pb="$8"
        >
          <VStack alignItems="center" gap="$8">
            <View />
            <WayupIllustration />
            <Text fontWeight="$bold" fontSize="$xl">
              Bem-vindo ao APP WayUp Negócios
            </Text>
            <View alignItems="flex-start">
              <Text>
                Aqui você encontra as melhores ferramentas para gerenciar as
                operações financeiras com eficiência:
              </Text>
            </View>
            <VStack gap="$8">
              {menuItems?.map((item) => (
                <HStack key={item.title} gap="$2">
                  <View flexGrow={1}>
                    <Icon
                      name={item.icon as IconNames}
                      variant="regular"
                      color="$primary600"
                      size={24}
                    />
                  </View>
                  <VStack $base-w="$full" $sm-maxWidth="$112" $base-pr="$8">
                    <Text fontWeight="$semibold">{item.title}</Text>
                    <Text>{item.description}</Text>
                  </VStack>
                </HStack>
              ))}
            </VStack>
          </VStack>
          <Button text="Começar" onPress={handleContinue} w="$full" />
        </View>
      </ScrollView>
    </View>
  );
};
